(function($) {
	'use strict';

	$.widget('msv.slideinSidebar', {
		vars: {
			desktopDown: window.matchMedia('(min-width: 1024px)')
		},

		_create: function() {
			var sidebar = $('.sidebar')
			if (this.vars.desktopDown.matches) {
				sidebar.hover(function() {
					$(this).addClass('open')
				}, function() {
					$(this).removeClass('open')
				})
			}
			else {
				sidebar.on('click', function() {
					$(this).toggleClass('open');
				})
			}
		},
	});

})(jQuery);